export const Default = {
    parentTrigger: "li",
    subMenu: "ul",
    toggle: true,
    triggerElement: "a"
};
export const ClassNames = {
    activeClass: "active",
    collapseClass: "collapse",
    collapseInClass: "in",
    collapsingClass: "collapsing"
};
